<template>
  <div ref="map" />
</template>

<script>
export default {
  props: [ 'options' ],
  watch: {
    'options'(cur) {
      if (!this.$_utils.isEmpty(this.mapInstance)) {
        this.mapInstance.setCenter(new window.kakao.maps.LatLng(cur.lat, cur.lng));
        this.mapInstance.setLevel(cur.level);
      }
    }
  },
  data() {
    return {
      mapInstance: null,
      clusterer: null
    }
  },
  mounted() {
    const vm = this;

    vm.$nextTick(() => {
      if (window.kakao && window.kakao.maps) {
        vm.initMap();
      } else {
        const script = document.createElement('script');
        /* global kakao */
        script.onload = () => kakao.maps.load(vm.initMap);
        script.src = `//dapi.kakao.com/v2/maps/sdk.js?autoload=false&libraries=services,clusterer&appkey=${process.env.VUE_APP_KAKAOMAP_APIKEY}`;
        document.head.appendChild(script);
      }
    })
  },
  methods: {
    initMap() {
      const vm = this;
      const container = this.$refs.map;

      vm.mapInstance = new window.kakao.maps.Map(container, {
        center: new window.kakao.maps.LatLng(vm.options.lat, vm.options.lng),
        level: vm.options.level
      });

      // Mouse Click Event
      window.kakao.maps.event.addListener(vm.mapInstance, 'click', (mouseEvent) => {
        let latLng = mouseEvent.latLng;
        console.log('Mouse Click 위치 [ 위도: ' + latLng.getLat().toFixed(6) + ', 경도: ' + latLng.getLng().toFixed(6) + ' ]')
      });

      // Map Level Change Event
      window.kakao.maps.event.addListener(vm.mapInstance, 'zoom_changed', () => {
        let mapLevel = vm.mapInstance.getLevel();
        console.log('변경된 지도 레벨 [ ' + mapLevel + ' ]')
      });

      // Map Zoom Control
      /*let zoomControl = new kakao.maps.ZoomControl();
      vm.mapInstance.addControl(zoomControl, kakao.maps.ControlPosition.BOTTOMRIGHT);*/

      vm.clusterer = new window.kakao.maps.MarkerClusterer({
        map: vm.mapInstance,
        averageCenter: true,   // 마커들의 평균 위치를 클러스터 마커 위치로 설정
        minLevel: 6,   // Cluster Map Level
        disableClickZoom: true,
        calculator: [10, 50, 100],   // 클러스터의 크기 구분 값, 각 사이 값마다 설정된 Text 나 Style 적용
        styles: [
          {
            width : '30px', height : '30px',
            background: 'rgb(239,225,6)',
            borderRadius: '15px',
            color: '#000',
            textAlign: 'center',
            fontWeight: 'bold',
            lineHeight: '31px'
          },
          {
            width : '40px', height : '40px',
            background: 'rgba(255, 153, 0, .8)',
            borderRadius: '20px',
            color: '#000',
            textAlign: 'center',
            fontWeight: 'bold',
            lineHeight: '41px'
          },
          {
            width : '50px', height : '50px',
            background: 'rgba(89,185,253,0.8)',
            borderRadius: '25px',
            color: '#000',
            textAlign: 'center',
            fontWeight: 'bold',
            lineHeight: '51px'
          },
          {
            width : '60px', height : '60px',
            background: 'rgba(255, 80, 80, .8)',
            borderRadius: '30px',
            color: '#000',
            textAlign: 'center',
            fontWeight: 'bold',
            lineHeight: '61px'
          }
        ]
      });

      window.kakao.maps.event.addListener(vm.clusterer, 'clusterclick', (cluster) => {
        let currentLevel = vm.mapInstance.getLevel()-1;
        vm.mapInstance.setLevel(currentLevel, {anchor: cluster.getCenter()});
      });

      this.$emit('checkInstance', vm.mapInstance)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
